import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { repeat, retry, take, timer, throwError, catchError } from 'rxjs';
import { AuthBackendService } from 'gung-standard';

@Component({
  selector: 'otto-maintenance',
  standalone: false,
  templateUrl: './otto-maintenance.component.html',
  styleUrl: './otto-maintenance.component.scss'
})
export class OttoMaintenanceComponent implements OnInit {
  maintenanceHeader = 'Down for maintenance:';
  maintenanceText = 'This site is currently down for maintenance but should be back up in a couple of minutes.';

  ngOnInit(): void {
    this.checkOnline();

    const currentDate = new Date();
    const startDate = new Date(currentDate.getFullYear(), 9, 24);
    const endDate = new Date(currentDate.getFullYear(), 9, 27);

    if (currentDate >= startDate && currentDate <= endDate) {
      this.maintenanceHeader = 'Kjære kunde:';
      this.maintenanceText =
        'Vi oppgraderer systemene våre gjennom helgen. Det betyr at nettbutikken til Otto Olsen er midlertidig utilgjengelig frem til mandag morgen kl 12:00.\n\n' +
        'Vi beklager ulempene dette eventuelt medfører, og takker for tålmodigheten.\n\n' +
        '- Otto Olsen';
    }
  }

  constructor(
    private router: Router,
    private authBackendService: AuthBackendService
  ) {}

  checkOnline() {
    this.authBackendService
      .getUser()
      .pipe(
        repeat({ delay: 5000 }),
        catchError(error => throwError(() => new Error(error))),
        retry({ count: 10, delay: (error, retryCount) => timer(5000) }),
        take(1)
      )
      .subscribe({
        next: v => {
          this.refreshApp();
        },
        error: e => {},
        complete: () => {}
      });
  }

  refreshApp() {
    // Navigate to the root path
    this.router.navigateByUrl('/').then(() => {
      // Reload the current page
      window.location.reload();
    });
  }
}
